// 26 estados + DF. Grava a sigla (acronym); o nome (label) só ajuda a escolher
const BR_STATES = [
  { acronym: 'AC', label: 'Acre' },
  { acronym: 'AL', label: 'Alagoas' },
  { acronym: 'AP', label: 'Amapá' },
  { acronym: 'AM', label: 'Amazonas' },
  { acronym: 'BA', label: 'Bahia' },
  { acronym: 'CE', label: 'Ceará' },
  { acronym: 'DF', label: 'Distrito Federal' },
  { acronym: 'ES', label: 'Espírito Santo' },
  { acronym: 'GO', label: 'Goiás' },
  { acronym: 'MA', label: 'Maranhão' },
  { acronym: 'MT', label: 'Mato Grosso' },
  { acronym: 'MS', label: 'Mato Grosso do Sul' },
  { acronym: 'MG', label: 'Minas Gerais' },
  { acronym: 'PA', label: 'Pará' },
  { acronym: 'PB', label: 'Paraíba' },
  { acronym: 'PR', label: 'Paraná' },
  { acronym: 'PE', label: 'Pernambuco' },
  { acronym: 'PI', label: 'Piauí' },
  { acronym: 'RJ', label: 'Rio de Janeiro' },
  { acronym: 'RN', label: 'Rio Grande do Norte' },
  { acronym: 'RS', label: 'Rio Grande do Sul' },
  { acronym: 'RO', label: 'Rondônia' },
  { acronym: 'RR', label: 'Roraima' },
  { acronym: 'SC', label: 'Santa Catarina' },
  { acronym: 'SP', label: 'São Paulo' },
  { acronym: 'SE', label: 'Sergipe' },
  { acronym: 'TO', label: 'Tocantins' },
]

// 50 estados + DC. Grava a sigla (acronym); o nome (label) só ajuda a escolher
const US_STATES = [
  { acronym: 'AL', label: 'Alabama' },
  { acronym: 'AK', label: 'Alaska' },
  { acronym: 'AZ', label: 'Arizona' },
  { acronym: 'AR', label: 'Arkansas' },
  { acronym: 'CA', label: 'California' },
  { acronym: 'CO', label: 'Colorado' },
  { acronym: 'CT', label: 'Connecticut' },
  { acronym: 'DE', label: 'Delaware' },
  { acronym: 'DC', label: 'District of Columbia' },
  { acronym: 'FL', label: 'Florida' },
  { acronym: 'GA', label: 'Georgia' },
  { acronym: 'HI', label: 'Hawaii' },
  { acronym: 'ID', label: 'Idaho' },
  { acronym: 'IL', label: 'Illinois' },
  { acronym: 'IN', label: 'Indiana' },
  { acronym: 'IA', label: 'Iowa' },
  { acronym: 'KS', label: 'Kansas' },
  { acronym: 'KY', label: 'Kentucky' },
  { acronym: 'LA', label: 'Louisiana' },
  { acronym: 'ME', label: 'Maine' },
  { acronym: 'MD', label: 'Maryland' },
  { acronym: 'MA', label: 'Massachusetts' },
  { acronym: 'MI', label: 'Michigan' },
  { acronym: 'MN', label: 'Minnesota' },
  { acronym: 'MS', label: 'Mississippi' },
  { acronym: 'MO', label: 'Missouri' },
  { acronym: 'MT', label: 'Montana' },
  { acronym: 'NE', label: 'Nebraska' },
  { acronym: 'NV', label: 'Nevada' },
  { acronym: 'NH', label: 'New Hampshire' },
  { acronym: 'NJ', label: 'New Jersey' },
  { acronym: 'NM', label: 'New Mexico' },
  { acronym: 'NY', label: 'New York' },
  { acronym: 'NC', label: 'North Carolina' },
  { acronym: 'ND', label: 'North Dakota' },
  { acronym: 'OH', label: 'Ohio' },
  { acronym: 'OK', label: 'Oklahoma' },
  { acronym: 'OR', label: 'Oregon' },
  { acronym: 'PA', label: 'Pennsylvania' },
  { acronym: 'RI', label: 'Rhode Island' },
  { acronym: 'SC', label: 'South Carolina' },
  { acronym: 'SD', label: 'South Dakota' },
  { acronym: 'TN', label: 'Tennessee' },
  { acronym: 'TX', label: 'Texas' },
  { acronym: 'UT', label: 'Utah' },
  { acronym: 'VT', label: 'Vermont' },
  { acronym: 'VA', label: 'Virginia' },
  { acronym: 'WA', label: 'Washington' },
  { acronym: 'WV', label: 'West Virginia' },
  { acronym: 'WI', label: 'Wisconsin' },
  { acronym: 'WY', label: 'Wyoming' },
]

// 17 departamentos + Asunción (distrito capital), pelo nome
const PY_DEPARTMENTS = [
  'Alto Paraguay',
  'Alto Paraná',
  'Amambay',
  'Asunción',
  'Boquerón',
  'Caaguazú',
  'Caazapá',
  'Canindeyú',
  'Central',
  'Concepción',
  'Cordillera',
  'Guairá',
  'Itapúa',
  'Misiones',
  'Ñeembucú',
  'Paraguarí',
  'Presidente Hayes',
  'San Pedro',
]

// 50 províncias + Ceuta e Melilla, pelo nome
const ES_PROVINCES = [
  'A Coruña',
  'Álava',
  'Albacete',
  'Alicante',
  'Almería',
  'Asturias',
  'Ávila',
  'Badajoz',
  'Baleares',
  'Barcelona',
  'Burgos',
  'Cáceres',
  'Cádiz',
  'Cantabria',
  'Castellón',
  'Ceuta',
  'Ciudad Real',
  'Córdoba',
  'Cuenca',
  'Girona',
  'Granada',
  'Guadalajara',
  'Guipúzcoa',
  'Huelva',
  'Huesca',
  'Jaén',
  'La Rioja',
  'Las Palmas',
  'León',
  'Lleida',
  'Lugo',
  'Madrid',
  'Málaga',
  'Melilla',
  'Murcia',
  'Navarra',
  'Ourense',
  'Palencia',
  'Pontevedra',
  'Salamanca',
  'Santa Cruz de Tenerife',
  'Segovia',
  'Sevilla',
  'Soria',
  'Tarragona',
  'Teruel',
  'Toledo',
  'Valencia',
  'Valladolid',
  'Vizcaya',
  'Zamora',
  'Zaragoza',
]

// Formato de endereço por país. As máscaras geram o formato que a PostalCodeRule da API
// cobra no atendimento. postalMask recebe os dígitos já digitados. Em states, cada item é
// o próprio valor gravado (texto) ou { acronym, label }, que grava o acronym. Os rótulos
// dos campos não mudam por país: a tradução vai vir do dicionário
const FORMATS = {
  BR: {
    postalMask: () => '99.999-999',
    postalLookup: true,
    states: BR_STATES,
    hasNeighborhood: true,
  },
  US: {
    // ZIP de 5 dígitos ou ZIP+4: o hífen só entra a partir do sexto dígito
    postalMask: digits => (digits.length <= 5 ? '99999?' : '99999-9999'),
    postalLookup: false,
    states: US_STATES,
    hasNeighborhood: false,
  },
  PY: {
    postalMask: () => '999999',
    postalLookup: false,
    states: PY_DEPARTMENTS,
    hasNeighborhood: true,
  },
  ES: {
    postalMask: () => '99999',
    postalLookup: false,
    states: ES_PROVINCES,
    hasNeighborhood: false,
  },
}

// País sem entrada (ou sem tenant) usa o formato do BR
export const getAddressFormat = country => FORMATS[country] || FORMATS.BR

// Aplica a máscara aos dígitos sem deixar separador sobrando no fim: "10118" fica
// "10118", e não "10118-" como o react-input-mask devolve
export const applyPostalMask = (mask, digits) => {
  let result = ''
  let next = 0

  for (let i = 0; i < mask.length && next < digits.length; i += 1) {
    if (mask[i] === '9' || mask[i] === '?') {
      result += digits[next]
      next += 1
    } else {
      result += mask[i]
    }
  }

  return result
}
